<script type="text/javascript">
	import { createEventDispatcher } from "svelte"

	import "./PropertyListComponent.scss";

	import PropertyList from "./PropertyList";
	const dispatch = createEventDispatcher(); // update

	export let name = "default";
	export let width = "100%";
	export let style = "";
	export let propertyList;

	let lastUpdated = propertyList.lastUpdated;
	$: {
		$lastUpdated;
		dispatch("update");
	}
	let textChanged = () => {
		propertyList.addOrRemovePropertyIfNecessary();
	};
</script>

<table class='property-list-table' style={"width:"+width+";"+style}>
	<thead style="display:table-header-group;">
		<tr>
			<th width="50%">Name</th>
			<th width="50%">Value</th>
		</tr>
	</thead>
	<tbody>
		{#each propertyList.properties as item, index}
			<tr>
				<td>
					<input id={"propertylist-property-"+name+"-"+index} type='text'
						bind:value={item.property}
						on:keyup={()=>{ textChanged(); }}
						placeholder="Input name..." />
				</td>
				<td>
					<input id={"propertylist-value-"+name+"-"+index} type='text'
							bind:value={item.value}
							on:keyup={()=>{ textChanged(); }}
							placeholder="Input value..."/>
				</td>
			</tr>
		{/each}
	</tbody>
</table>
